/**
 * Campos elegibles para total de columna en listados dinámicos.
 */

export function isSummableListField(field) {
  if (!field) return false;

  if (field.type === "reference_subfield") {
    const subType =
      field.nestedSubFieldDef?.type || field.subFieldType || field.subFieldDef?.type;
    if (
      subType === "number" ||
      subType === "integer" ||
      subType === "float" ||
      subType === "currency"
    ) {
      return true;
    }
    return !!(
      field.subFieldDef?.currency === true ||
      field.nestedSubFieldDef?.currency === true
    );
  }

  if (field.type === "group_subfield") {
    const subType = field.subFieldType || field.subFieldDef?.type;
    if (
      subType === "number" ||
      subType === "integer" ||
      subType === "float" ||
      subType === "currency"
    ) {
      return true;
    }
    return field.subFieldDef?.currency === true;
  }

  const t = field.type;
  if (t === "number" || t === "integer" || t === "float" || t === "currency") {
    return true;
  }

  return false;
}

export function activeColumnTotalKeys(columnTotals) {
  if (!columnTotals || typeof columnTotals !== "object") return [];
  return Object.entries(columnTotals)
    .filter(([, enabled]) => enabled === true)
    .map(([key]) => key);
}
